module.exports = __webpack_public_path__ + "img/icon-white-1.743d48ad.svg";